<template>
  <!-- Limitation: Ne peut être un Area. Doit être un component -->
  <!-- Cause: on ne connait pas le parentTemplateId -->
  <div v-if="contentHerite || contentHeritage" :class="jel_getClassObject(content)">
    <component
      :is="nomComponent(metadataHerite)"
      v-if="contentHerite"
      :key="metadataHerite['@id']"
      :metadata="metadataHerite"
      :content="contentHerite"
    />
    <div v-else-if="contentHeritage">
      <div v-for="component in contentHeritage['@nodes']" :key="component['@id']">
        <component
          :is="nomComponent(getComponentMetadata(contentHeritage[component]))"
          :metadata="getComponentMetadata(contentHeritage[component])"
          :content="getComponentContent(contentHeritage[component])"
        />
      </div>
    </div>
  </div>
</template>

<script>
import BanniereLaterale from '@/components/base/BanniereLaterale';
import Catfish from '@/components/base/Catfish';
import EntetePage from '@/components/container/entete/EntetePage';
import EnteteSection from '@/components/container/entete/EnteteSection';
import Formulaire from '@/components/formulaire/Formulaire';
import GrandeSection from '@/components/container/entete/GrandeSection';
import Hyperlien from '@/components/base/Hyperlien';
import ListeCatfish from '@/components/container/liste/ListeCatfish';
import ListeHorizontale from '@/components/container/liste/ListeHorizontale';
import ListeNotifications from '@/components/container/liste/ListeNotifications';
import MediaImage from '@/components/media/image/MediaImage';
import Paragraphe from '@/components/base/Paragraphe';
import Row from '@/components/container/grid/Row';
import SectionLiens from '@/components/container/liste/SectionLiens';
import Titre from '@/components/base/Titre';

import { getProps } from '@/vue-editor';
import { getUrlContext } from '@/helpers/AppHelpers';

import i18n from '@/js/i18n';

export default {
  name: 'Heritage',
  components: {
    BanniereLaterale,
    Catfish,
    EntetePage,
    EnteteSection,
    Formulaire,
    GrandeSection,
    Hyperlien,
    ListeCatfish,
    ListeHorizontale,
    ListeNotifications,
    MediaImage,
    Paragraphe,
    Row,
    SectionLiens,
    Titre,
  },
  props: { content: { type: Object, required: true } },
  data() {
    return {
      contentHeritage: null,
      contentHerite: null,
      metadataHerite: null,
    };
  },
  created() {
    this.loadHeritage();
  },
  methods: {
    async loadHeritage() {
      const contentResponse = await fetch(await this.getContentUrl());
      const content = await contentResponse.json();
      if (content.main) {
        this.contentHeritage = content.main;
      } else {
        const props = getProps(content);
        this.metadataHerite = props.metadata;
        this.contentHerite = props.content;
      }
    },

    async getContentUrl() {
      const lienInterne = this.jel_nettoyerLienInterne(this.content.lienInterne);
      if (!lienInterne) return null;
      return getUrlContext(`${process.env.VUE_APP_REST_PAGES + lienInterne}?lang=${i18n.locale}`);
    },
    getComponentMetadata(component) {
      const props = getProps(component);
      return props.metadata;
    },
    getComponentContent(component) {
      const props = getProps(component);
      return props.content;
    },
    nomComponent(metadata) {
      try {
        const mgnlTemplate = metadata['mgnl:template'].split('/').pop();
        return mgnlTemplate.charAt(0).toUpperCase() + mgnlTemplate.slice(1);
      } catch (error) {
        // Erreur causée principalement parce que le lien vers le contenu héritage est mal défini
        console.warn(`Erreur dans la définition du lien héritage: ${metadata['mgnl:template']}`);
        return null;
      }
    },
  },
};
</script>
